import Api from '@/api/api.js'

export default {
    getListeHistoriqueConsultation(data) {
        const promise = Api().post('/historiques/consultation', data)
        return promise.then(response => response.data)
    },

    getListeConsultationsPatient(patient_id) {
        const promise = Api().get('/historiques/patient/'+patient_id+'/consultations')
        return promise.then(response => response.data)
    },
}